import { render, staticRenderFns } from "./PowerOfPointViz.vue?vue&type=template&id=627beaa4&scoped=true"
import script from "./PowerOfPointViz.vue?vue&type=script&lang=js"
export * from "./PowerOfPointViz.vue?vue&type=script&lang=js"
import style0 from "./PowerOfPointViz.vue?vue&type=style&index=0&id=627beaa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627beaa4",
  null
  
)

export default component.exports